import { NON_SUBDOMAIN_EVENT_PATH, ORDER_CLOUD_PROXY_DOMAIN, ORDER_CLOUD_SEARCH_PATH, SEARCH_API_DOMAINS, } from './types.js';
const composeAPIEndPoints = (ocRegion, env, domainId) => {
    return {
        useAccessToken: true,
        apiDomain: ORDER_CLOUD_PROXY_DOMAIN[ocRegion],
        searchUrl: `${ORDER_CLOUD_PROXY_DOMAIN[ocRegion]}${ORDER_CLOUD_SEARCH_PATH.replace('{{domain}}', domainId)}`,
        eventUrl: `${SEARCH_API_DOMAINS[env]}${NON_SUBDOMAIN_EVENT_PATH.replace('{{key}}', domainId)}`,
    };
};
const OrderCloudConfig = {
    build: (config, setupOptions) => {
        const newConfig = Object.assign({}, config, setupOptions);
        const { orderCloudRegion = 'usWest', env = 'prod', discoverDomainId } = setupOptions;
        if (!discoverDomainId) {
            throw new Error('{discoverDomainId} has not been provided.');
        }
        newConfig.domainId = discoverDomainId;
        newConfig.connector = 'oc';
        return Object.assign(newConfig, composeAPIEndPoints(orderCloudRegion, env, discoverDomainId));
    },
};
export default OrderCloudConfig;
